// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__r44wT","wrapper":"styles_wrapper__DpXoZ","text":"styles_text__Uf9ZJ"};